const feedbackActions = {
  GET_FEEDBACK_QUESTIONS : 'GET_FEEDBACK_QUESTIONS',
  SET_FEEDBACK_QUESTIONS : 'SET_FEEDBACK_QUESTIONS',
  SET_FEEDBACK_SUBMIT_ANSWER : 'SET_FEEDBACK_SUBMIT_ANSWER',
  GET_FEEDBACK_SUBMIT_ANSWER : 'GET_FEEDBACK_SUBMIT_ANSWER',
  AUDIT_LOG_FEEDBACK : 'AUDIT_LOG_FEEDBACK',
}

export default feedbackActions;